<app-employee-header-card-widget
    [employee]="model?.employee ?? model"
    [fallbackAsset]="props.fallbackAsset ?? model?.user?.featuredAsset"
    [showContactActions]="props.showContactActions !== false"
    [showIdentifier]="props.showIdentifier !== false"
    [formControl]="formControl"
    [form]="form"
    [loadingSig]="this.options.formState.detailComponent.loading"
    [key]="this.key"
    (employeeChanged)="onEmployeeChanged($event)"
    (assetChoose)="onAssetChoose($event)"
/>
